import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-733320a9"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 1,
    class: "avatar__icon"
};
var _hoisted_2 = {
    key: 2,
    class: "avatar__icon"
};
import { computed } from 'vue';
import { getAvatarColors } from '@common/utils/Colors/Colors';
import EIcon from '@common/ui/EIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EAvatar',
    props: {
        src: {},
        icon: {},
        colorId: { default: '3' },
        name: {},
        primary: { type: Boolean, default: false },
        mobile: { type: Boolean, default: false }
    },
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var emit = __emit;
        var props = __props;
        var avatarName = computed(function () { return props.name || 'A'; });
        var shortname = computed(function () {
            if (!avatarName.value)
                return '';
            return avatarName.value.trim().split(/\s+/)
                .map(function (word) { var _a; return ((_a = word[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || ''; })
                .slice(0, 2)
                .join('');
        });
        var bgColor = computed(function () {
            if (props.primary || props.src || !props.colorId)
                return '';
            return getAvatarColors(props.colorId)[0];
        });
        var textColor = computed(function () {
            if (props.primary)
                return '';
            if (!props.colorId)
                return '';
            return getAvatarColors(props.colorId)[1];
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([[
                        _ctx.primary ? 'hover:!bg-primary/30 !bg-primary/20' : '',
                        _ctx.mobile && 'avatar__mobile',
                    ], "avatar"]),
                style: _normalizeStyle({
                    'background-color': bgColor.value,
                })
            }, [
                (_ctx.src)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle({
                            'background-image': 'url(' + _ctx.src + ')'
                        }),
                        class: "avatar__image"
                    }, null, 4))
                    : (_ctx.icon)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(EIcon, {
                                class: _normalizeClass({
                                    '!text-primary': _ctx.primary,
                                }),
                                icon: _ctx.icon
                            }, null, 8, ["class", "icon"])
                        ]))
                        : (!_ctx.name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(EIcon, {
                                    class: _normalizeClass([{
                                            '!text-primary': _ctx.primary,
                                            'w-2.5 h-2.5': _ctx.mobile
                                        }, "w-5 h-5"]),
                                    icon: "image-stack"
                                }, null, 8, ["class"])
                            ]))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 3,
                                class: _normalizeClass([[
                                        {
                                            'avatar__initials--smalltext': shortname.value.length === 2,
                                            '!text-primary': _ctx.primary,
                                        }
                                    ], "avatar__initials"]),
                                style: _normalizeStyle({
                                    'color': textColor.value,
                                })
                            }, [
                                _createElementVNode("span", null, _toDisplayString(shortname.value), 1)
                            ], 6))
            ], 6));
        };
    }
});
